// ============================================
// API Client — запросы к Worker
// ============================================

const API_URL = 'https://samsa-worker.samsa-bot.workers.dev';

console.log('API_URL initialized:', API_URL);

async function request<T>(path: string, options?: { method?: string; body?: any }): Promise<T> {
  const url = `${API_URL}${path}`;
  console.log('Fetching:', url, 'Method:', options?.method || 'GET');
  
  try {
    const res = await fetch(url, {
      method: options?.method || 'GET',
      headers: { 'Content-Type': 'application/json' },
      body: options?.body ? JSON.stringify(options.body) : undefined,
    });

    console.log('Response status:', res.status);

    if (!res.ok) {
      const error = await res.json().catch(() => ({ error: 'Unknown error' }));
      console.error('API Error:', error);
      throw new Error(error.error || `HTTP ${res.status}`);
    }

    const data = await res.json();
    console.log('Response data:', data);
    return data;
  } catch (e: any) {
    console.error('Fetch failed:', e.message, e);
    throw e;
  }
}

// ============================================
// Components
// ============================================

export async function getComponents() {
  return request<{ components: any[] }>('/api/components');
}

export async function getComponent(id: number) {
  return request<{ component: any }>(`/api/components/${id}`);
}

// ============================================
// Landing Draft
// ============================================

export async function createDraft(data: {
  telegram_id: number;
  title: string;
  country: string;
  city: string;
  slug: string;
  data: Record<string, any>;
  components: Array<{ component_id: number; position: number; data: Record<string, any> }>;
}) {
  return request<{ success: boolean; landing_id: string; slug: string; status: string }>(
    '/api/landing/draft',
    { method: 'POST', body: data }
  );
}

export async function updateDraft(id: string, data: Record<string, any>) {
  return request<{ success: boolean }>(
    `/api/landing/draft/${id}`,
    { method: 'PUT', body: data }
  );
}

export async function getLanding(id: string) {
  return request<{ landing: any }>(`/api/landing/${id}`);
}

// ============================================
// Payment
// ============================================

export async function createPayment(telegramId: number, landingId: string, promocode?: string) {
  return request<{ 
    success: boolean; 
    invoice_url?: string; 
    payment_method: string;
    free?: boolean;
    url?: string;
    promocode_used?: boolean;
    amount_stars?: number;
  }>(
    '/api/payment/create',
    {
      method: 'POST',
      body: { telegram_id: telegramId, landing_id: landingId, promocode },
    }
  );
}

// ============================================
// Promocode
// ============================================

export async function checkPromocode(code: string, telegramId: number) {
  return request<{ valid: boolean; reason?: string; remaining_uses?: number }>(
    '/api/promocode/check',
    {
      method: 'POST',
      body: { code, telegram_id: telegramId },
    }
  );
}

// ============================================
// User Landings
// ============================================

export async function getUserLandings(telegramId: number) {
  return request<{ telegram_id: number; landings: any[]; total: number }>(
    `/api/user/${telegramId}/landings`
  );
}
